import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import {getFormValues} from 'redux-form'
import {hideConfirmSubmitModal, confirmSubmit} from 'actions/inventory/adjustment'
import styles from './ConfirmSubmitModal.css'

class ConfirmSubmitModal extends React.Component {
  render () {
    const {showConfirmSubmitModal} = this.props
    return (<Modal show={showConfirmSubmitModal} dialogClassName={styles['modal-dialog']}>
      <Modal.Header bsClass={`modal-header ${styles['modal-header']}`}>
        Information
      </Modal.Header>
      <Modal.Body>
        Do you want to save the adjustment? You will not be able to modify after changes are made.
      </Modal.Body>
      <Modal.Footer>
        <button type='button' onClick={this._onHide} className='btn btn-default'>Cancel</button>
        <button
          type='button'
          className='btn btn-primary'
          onClick={this._onClickCreate}
        >
          Create
        </button>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    const {dispatch} = this.props
    dispatch(hideConfirmSubmitModal())
  }

  _onClickCreate = () => {
    const {adjustmentForm, dispatch, search: {date}, outlets} = this.props
    let outlet = {}
    outlets.forEach(o => {
      if (o.id === adjustmentForm.outlet_id) {
        outlet = o
      }
    })
    const namespace = this._namespace()
    dispatch(confirmSubmit(adjustmentForm, namespace, date, outlet))
  }

  _namespace = () => {
    const {search} = this.props
    if (search) {
      return search.namespace
    } else {
      return ''
    }
  }
}

function mapStateToProps (state) {
  const {showConfirmSubmitModal, outlets} = state.inventory.adjustment
  return {
    adjustmentForm: getFormValues('adjustment')(state),
    showConfirmSubmitModal,
    search: getFormValues('search')(state),
    outlets
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmSubmitModal)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Adjustment/AdjustmentDetail/AdjustmentForm/ConfirmSubmitModal/ConfirmSubmitModal.js